<template>
    <div>
        <button id="buttonOpenModal" @click="openModal" class="btn btn-red inline-block sm:w-auto w-full py-2 px-5">
            Reactivar membresía
        </button>
        <div
            id="reactivationModal"
            class="modal"
            data-backdrop="true"
            :class="{ show: showReactivationModal, fadeOut: modalFadeout }"
            tabindex="-1"
        >
            <div class="modal-content modal-md">
                <div>
                    <div class="modal-close-container">
                        <button type="button" class="modal-close" data-miss="#reactivationModal" @click="closeModal">
                            <svg
                                width="25"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                                role="img"
                                aria-label="Icono para cerrar mensaje"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-container">
                        <svg
                            class="w-16 mx-auto text-green-600"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 363.76 363.76"
                        >
                            <path
                                fill="currentColor"
                                stroke="10"
                                d="M163.19 260.7a9.42 9.42 0 01-13.32 0h0l-53.22-53.21a14.13 14.13 0 010-20h0l6.68-6.64a14.11 14.11 0 0120 0h0l33.22 33.21 89.74-89.76a14.13 14.13 0 0120 0h0l6.67 6.66a14.12 14.12 0 010 20h0z"
                            />
                            <path
                                fill="currentColor"
                                stroke="10"
                                d="M181.89 361.76C82.7 361.76 2 281.07 2 181.88S82.7 1.96 181.89 1.96s179.88 80.73 179.88 179.92-80.7 179.88-179.88 179.88zm0-325.76C101.45 35.96 36 101.44 36 181.88s65.45 145.88 145.89 145.88 145.88-65.44 145.88-145.88S262.32 35.96 181.89 35.96z"
                            />
                        </svg>
                        <h6 class="text-xl font-semibold text-center leading-tight mt-5">
                            Tu cuenta se reactivará con los siguientes datos
                        </h6>
                        <p class="text-center mt-6">
                            Recibirás un correo electrónico con la confirmación de tu reactivación. Estos son tus datos
                            de facturación:
                        </p>
                        <div class="mt-8">
                            <div class="flex items-center justify-between text-sm first:mt-0 mt-3">
                                <p>Tu cuenta:</p>
                                <strong>
                                    {{ email }}
                                </strong>
                            </div>
                            <div class="flex items-center justify-between text-sm first:mt-0 mt-3">
                                <p>Método de pago:</p>
                                <strong class="inline-flex items-center">
                                    <img :src="brandCard | toBrandLogo" class="w-7 mr-3" alt="Imagen de tarjeta" />
                                    terminación {{ lastFourDigits }}
                                </strong>
                            </div>
                        </div>
                        <p class="text-center mt-6">Nueva fecha de facturación:</p>
                        <h6 class="text-base text-center">{{ nextPaymentDate }}</h6>
                        <div class="flex items-center justify-between mt-6">
                            <a
                                href="/mi-cuenta/metodos-de-pago"
                                class="inline-block text-blue-500 hover:text-blue-700 outline-none transition duration-300 ease-in-out underline"
                                >Cambiar método de pago</a
                            >
                            <button
                                @click="reactivate"
                                class="btn btn-red inline-block sm:px-12 px-6 py-2 modal-close"
                                data-miss="#reactivationModal"
                            >
                                Finalizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop"></div>
        </div>
        <div
            id="addPaymentMethodModal"
            class="modal"
            data-backdrop="true"
            :class="{ show: showReactivationPaymentModal, fadeOut: modalFadeout }"
            tabindex="-1"
        >
            <div class="modal-content modal-md">
                <div>
                    <div class="modal-close-container">
                        <button
                            type="button"
                            class="modal-close"
                            data-miss="#addPaymentMethodModal"
                            @click="closeModal"
                        >
                            <svg
                                width="25"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                                role="img"
                                aria-label="Icono para cerrar mensaje"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-container">
                        <svg
                            class="w-16 mx-auto text-gray-300"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                        >
                            <path
                                fill="currentColor"
                                d="M372.352 214.332a31.741 31.741 0 00-7.942 4.23c-12.555 9.239-35.96 34.473-35.96 34.473.718-.676-16.856 16.328-32.97 32.035-4.52 4.41-12.117 1.243-12.171-5.074V76.473c0-19.95-16.133-33.711-35.657-29.61-15.578 3.274-23.89 17.766-23.89 35.094l.136 153.633-23.746.055V27.735c0-19.036-15.28-31.532-33.691-26.688-12.633 3.32-18.547 15.21-18.547 30.203v204.68l-23.676.05-.136-166.304c0-16.617-7.836-31.274-24.446-31.766-17.261-.512-25.574 13.969-25.574 31.117l-.246 167.227-23.145.047V126.69c0-17.265-8.03-30.308-25.39-30.308C8.03 96.383 0 109.426 0 126.69l.02 243.332C8.68 495.125 79.402 512 153.332 512c61.25 0 110.25-30.383 137.375-78.95 3.492-5.632 12.93-20.476 24.121-38.058 15.918-25.004 30.363-47.375 40.5-63.226 13.363-20.903 25.598-37.23 40.73-56.891 4.212-5.469 7.7-9.871 9.364-11.691 4.558-4.977 7.562-11.168 8.46-17.852v-1.262c0-24.129-18.87-38.02-41.53-29.738zm0 0"
                            ></path>
                        </svg>
                        <h6 class="text-xl font-semibold text-center leading-tight mt-5">Reactivación de cuenta</h6>
                        <p class="text-center mt-6">
                            Para poder realizar la reactivación de tu cuenta es necesario agregar un
                            <strong>método de pago</strong> y posteriormente recibirás tu nueva fecha de facturación.
                        </p>
                        <div class="flex items-center justify-between mt-8">
                            <button
                                @click="closeModal"
                                class="inline-block text-blue-500 hover:text-blue-700 outline-none transition duration-300 ease-in-out underline lg:ml-6 sm:ml-12 modal-close"
                                data-miss="#addPaymentMethodModal"
                            >
                                Cancelar
                            </button>
                            <a href="/mi-cuenta/metodos-de-pago" class="btn btn-red inline-block sm:px-5 px-4 py-2"
                                >Agregar método de pago</a
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop"></div>
        </div>
    </div>
</template>

<script>
import sweetAlert from 'sweetalert2';
import { toBrandLogo } from '../filters';
export default {
    name: 'ReactivationSubscriptionModal',

    props: {
        email: String,
        brandCard: String | null,
        lastFourDigits: String | null,
        subscriptionId: String,
        nextPaymentDate: String,
    },

    filters: {
        toBrandLogo,
    },

    data() {
        return {
            showReactivationModal: false,
            showReactivationPaymentModal: false,
            modalFadeout: false,
        };
    },

    methods: {
        openModal() {
            if (this.brandCard !== '' && this.lastFourDigits !== '') {
                return (this.showReactivationModal = true);
            }

            return (this.showReactivationPaymentModal = true);
        },

        closeModal() {
            this.modalFadeout = true;
            $('body, html').removeClass('overflow-hidden');
            setTimeout(() => {
                this.showReactivationModal = false;
                this.showReactivationPaymentModal = false;
                this.modalFadeout = false;
            }, 700);
        },

        reactivate() {
            axios.post(`/suscripcion/${this.subscriptionId}/reactivate`).then(() => {
                sweetAlert
                    .fire({
                        title: 'Suscripción activa',
                        html: 'A partir de este momento tu cuenta ha sido reactivada con éxito. Ya puedes disfrutar de todos los beneficios que <span class=text-red-500>Círculo Plus</span> tiene para ti.',
                        icon: 'success',
                        confirmButtonText: 'Cerrar',
                        buttonsStyling: false,
                        customClass: {
                            confirmButton: 'btn btn-green inline-block py-3 px-10',
                        },
                    })
                    .then(() => {
                        this.loading = true;

                        location.href = '/mi-cuenta/suscripcion';
                    });
            });
        },
    },
};
</script>
